import {
  ContentWidth,
  TextWidth,
  TextWidthExtended,
} from '@ta-interaktiv/react-disco-grid'
import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'
import Typewriter from 'typewriter-effect'


const Header = ({
  tenant,
  colorMode,
  heading,
  title,
  lead
}: {
  tenant: string
  colorMode: 'light' | 'dark' | undefined
  heading?: string
  title?: string
  lead?: string
}) => {
  const { width, height } = useWindowSize()
  const [screenHeight, setScreenHeight] = useState<number>(0)
  useEffect(() => {
    setScreenHeight(height)
  }, [width])
  const renderedLead = lead ?? "Wie clever und kreativ ist die künstliche Intelligenz bei der Spracherzeugung wirklich? Probieren Sie das zurzeit beste Textprogramm selber aus."
  const renderedTitle = title ?? "Wer schreibt besser, Sie oder die Maschine? Testen Sie den Textroboter!"
  return (
    <StyledHeader screenHeight={screenHeight}>
      {/* <img src={require('./header-01.png')} /> */}
      <TextWidth>
        <Headline>
        <Typewriter
                  options={{ delay: 40 }}
                  onInit={(typewriter) => {
                    typewriter.typeString(renderedTitle).start()
                  }}
                />
          </Headline>
        <Lead>
        {/* <Typewriter
                  options={{ delay: 40, cursor: '' }}
                  onInit={(typewriter) => {
                    setTimeout(() => {

                      typewriter.typeString(renderedLead).start()
                    }
                    , 4000)
                  }}
                /> */}
{

renderedLead
}
        </Lead>
        <Authors colorMode={colorMode} className='ContentMetaInfo'>
          <span key={68585244}>
            <a
              href={`https://www.${tenant}.ch/author/${68585244}/dariush-mehdiaraghi`}
            >
              Dariush Mehdiaraghi
            </a>
          </span>
          <span key={16970675}>
            <a
              href={`https://www.${tenant}.ch/author/${16970675}/dominik-balmer`}
            >
              Dominik Balmer
            </a>
          </span>
        </Authors>
      </TextWidth>
    </StyledHeader>
  )
}
const Authors = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  color: var(--text-color);
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  line-height: 1.8rem;
  border-top: ${({ colorMode }) =>
    colorMode === 'dark'
      ? '1px solid var(--gray-2)'
      : '1px solid var(--gray-4)'};
  padding-top: 2rem;
  a {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
  }
  span::after {
    content: ', ';
  }
  span:last-child::after {
    content: '';
  }
`
const StyledHeader = styled.div<{ screenHeight: number }>`
  text-align: center;
  /* padding-top: ${({ screenHeight }) => screenHeight * 0.1 + 'px'}; */
  margin-bottom: 60px;
  img {
    max-width: 100vw;
  }
`
const Headline = styled.h1`
  /* font-family: var(--font-suez); */
  .Typewriter__cursor{
    animation: Typewriter-cursor 1s infinite ease-in-out;
    @keyframes Typewriter-cursor {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }}
  }
  font-family: 'Courier New', Courier, monospace;

  font-size: 60px;
  line-height: 1.2em;
  margin-bottom: 0;
  margin-top: 1em;
  @media only screen and (max-width: 711px) {
    font-size: 30px;
  }
`
const Lead = styled.h2`
  font-family: var(--font-sans-serif);
  /* font-family: 'Courier New', Courier, monospace; */

  font-size: 26px;
  font-weight: 300;
  line-height: 1.3em;

  @media only screen and (max-width: 711px) {
    font-size: 18px;
    padding-left: 1em;
    padding-right: 1em;
  }
`
export default Header